;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.config')
    .constant('_', _)
    .config(Configuration)

  Configuration.$inject = [
    // Angular
    '$httpProvider', '$locationProvider', '$urlRouterProvider', '$qProvider',
    // Libs
    '$breadcrumbProvider', 'ChartJsProvider', 'jwtInterceptorProvider', 'zlAuthProvider', 'HttpRetryerProvider',
    // Managers
    // Services
    // Const
    'appId', 'urls'
    // Resolved
  ]

  function Configuration (// Angular
    $httpProvider, $locationProvider, $urlRouterProvider, $qProvider,
    // Libs
    $breadcrumbProvider, ChartJsProvider, jwtInterceptorProvider, zlAuthProvider, HttpRetryerProvider,
    // Managers
    // Services
    // Const
    appId, urls
    // Resolved
  ) {
    zlAuthProvider.setAppId(appId)
      .setRootUrl(urls.auth)
      .setLoginRoute('/login')
      .setRefreshRoute('/refresh/')
      .setLogoutRoute('/logout')

    // $qProvider.errorOnUnhandledRejections(false)
    jwtInterceptorProvider.tokenGetter = ['$http', 'jwtHelper', 'zlAuth', function ($http, jwtHelper, zlAuth) {
      return zlAuth.getToken()
    }]

    $breadcrumbProvider.setOptions({
      templateUrl: '/app/common/layouts/partials/breadcrumb.html'
    })

    $urlRouterProvider.otherwise('/invoice/list')

    // limits
    // HttpRetryerProvider.setTimeout(30000) replaced in xhrFactory
    HttpRetryerProvider.setMaxRetries(2)
    // Remove hashtag navigation
    $locationProvider.html5Mode(true).hashPrefix('!')

    // Add authentication interceptors for HTTP Requests
    $httpProvider.interceptors.push('jwtInterceptor')
    $httpProvider.interceptors.push('HttpRetryer')
    $httpProvider.interceptors.push('HttpErrorInterceptor')

  }
})(window.angular, window._)
